import {Coordinates} from '@/common/interfaces/geolocation';
import {AbstractFetcher} from '@/common/services/fetcher/AbstractFetcher';

export class FeedbackAPI {
	constructor(private readonly fetcher: AbstractFetcher) {
		fetcher.setDefaultParams({
			method: 'POST',

			headers: {
				// Default post data type
				'Content-Type': 'application/json',

				// Add specific static XHR header required by server
				'X-Requested-With': 'XMLHttpRequest',
			},
			// Rewrite an empty body with an empty JSON object
			postData: '{}',
		});
	}

	async sendFeedback(
		mode: 'general' | 'ads',
		email: string,
		text: string,
		client: {
			name: string;
			version: string;
			screen: {
				width: number;
				height: number;
			};
			geoLocation?: Coordinates;
		},
	) {
		await this.fetcher.fetch('/api/feedback/submit', {
			/* eslint-disable @typescript-eslint/naming-convention */
			type: mode,
			contact_email: email,
			text,
			client: {
				name: client.name,
				version: client.version,
				screen: client.screen,
				geo_location: client.geoLocation,
			},
			/* eslint-enable @typescript-eslint/naming-convention */
		});
	}
}
